import { render, staticRenderFns } from "./SettingsCard.vue?vue&type=template&id=78c8a2b2&scoped=true"
import script from "./SettingsCard.vue?vue&type=script&lang=js"
export * from "./SettingsCard.vue?vue&type=script&lang=js"
import style0 from "./SettingsCard.vue?vue&type=style&index=0&id=78c8a2b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c8a2b2",
  null
  
)

export default component.exports